import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import Toggle from 'react-toggle'
import Loading from './widgets/Loading'
import role from '../util/role'
import ReactModal from "react-modal";
import {
    TOKEN_DETAIL_PAGE_LOADED,
    TOKEN_DETAIL_PAGE_UNLOADED,
    TOKEN_APPROVE,
    TOKEN_REJECT,
    TOKEN_PAUSE,
    TOKEN_UNPAUSE
} from '../constants/actionTypes';
import { TOKEN_STATUS, REACT_APP_DASHBOARD_URL } from '../constants/config'

const mapStateToProps = state => ({
    ...state.token,
    currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
    onLoad: payload =>
        dispatch({ type: TOKEN_DETAIL_PAGE_LOADED, payload }),
    onUnload: () =>
        dispatch({ type: TOKEN_DETAIL_PAGE_UNLOADED }),
    onApprove: (payload) => {
        dispatch({ type: TOKEN_APPROVE, payload })
    },
    onReject: (payload) => {
        dispatch({ type: TOKEN_REJECT, payload })
    },
    onPause: (payload) => {
        dispatch({ type: TOKEN_PAUSE, payload })
    },
    onUnPause: (payload) => {
        dispatch({ type: TOKEN_UNPAUSE, payload })
    },
});

class TokenDetail extends React.Component {
    constructor() {
        super();
        this.state = {
            code: '',
            reason: '',
            modalMessage: '',
            actionType: '',
            showConfirmModal: false,
            showVerificationCodeModal: false
        }

        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
    }
    componentWillMount() {
        const symbol = this.props.match.params.symbol
        const payload = agent.Tokens.getToken(symbol)

        this.props.onLoad(payload);
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.codeStatus !== nextProps.codeStatus && nextProps.codeStatus && nextProps.codeStatus === 'sent') {
            this.setState({ showConfirmModal: false, showVerificationCodeModal: true })
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }
    handleClick = (action) => {
        this.setState({ code: '', actionType: action });
        let message = `Are you sure you want to ${action} this token?`;
        if (action === "complete") {
            message = `Are you sure you want to unpause this token?`;
        }
        this.setState({ modalMessage: message, showConfirmModal: true })
    };
    handleConfirmSubmit = () => {
        const symbol = this.props.match.params.symbol
        this.setState({ showConfirmModal: false, showVerificationCodeModal: false })
        const actionType = this.state.actionType
        if (actionType === "reject") {
            const payload = agent.Tokens.rejectToken(symbol, this.state.reason, this.state.code)
            this.props.onReject(payload)
        } else if (actionType === "approve") {
            const payload = agent.Tokens.approveToken(symbol, this.state.code)
            this.props.onApprove(payload)
        } else if (actionType === "complete") {
            const payload = agent.Tokens.enableToken(symbol, this.state.code)
            this.props.onUnPause(payload)
        } else if (actionType === "pause") {
            const payload = agent.Tokens.pauseToken(symbol, this.state.code)
            this.props.onPause(payload)
        }
    };

    getParent = () => {
        return document.querySelector(".pane");
    };
    render() {
        if (!this.props.token) {
            return (
                <Loading />
            )
        }

        const token = this.props.token

        return (
            <div class='pane'>
                <Link className="crumb" to="/tokens">&laquo; back to tokens</Link>
                <h1>{token.name} Details</h1>
                <ListErrors errors={this.props.errors} />
                <div className="infoGroup">
                    {
                        token.logo ? <div className="infoPair">
                            <label>Logo</label>
                            <span> <img id='token-logo' src={token.logo} /></span>
                        </div> : null
                    }
                    <div className="infoPair">
                        <label>Owner:</label> <span><Link to={`/users/${token.owner}`}>{token.owner} &raquo;</Link></span>
                    </div>
                    <div className="infoPair">
                        <label>Status:</label> <span>{token.generated_status}</span>
                    </div>
                    <div className="infoPair">
                        <label>Name:</label> <span>{token.name}</span>
                    </div>
                    <div className="infoPair">
                        <label>Symbol:</label> <span>{token.symbol}</span>
                    </div>
                    <div className="infoPair">
                        <label>Total Pool:</label> <span>{token.total}</span>
                    </div>
                    <div className="infoPair">
                        <label>Website:</label> <span>{token.website}</span>
                    </div>
                    <div className="infoPair">
                        <label>Description:</label> <span>{token.description}</span>
                    </div>
                    <div className="infoPair">
                        <label>Fixed Supply:</label> <span>{token.fixed ? 'Yes' : 'No'}</span>
                    </div>
                    <div className="infoPair">
                        <label>Burn Used:</label> <span>{token.burn ? 'Yes' : 'No'}</span>
                    </div>
                    <div className="infoPair">
                        <label>Enable Mining:</label> <span>{token.mining ? 'Yes' : 'No'}</span>
                    </div>
                    {
                        token.mining ? <div className="infoPair">
                            <label>Mining Pool:</label> <span>{token.mining_details.mining_pool * 100} %</span>
                        </div> : null
                    }
                    <div className="infoPair">
                        <label>Airdrop Reserve:</label> <span>{token.airdrop ? 'Yes' : 'No'}</span>
                    </div>
                    {
                        token.airdrop ? <div>
                            <div className="infoPair">
                                <label>Airdrop Pool:</label> <span>{token.airdrop_details.airdrop_pool * 100} %</span>
                            </div>
                            <div className="infoPair">
                                <label>Airdrop Address:</label> <span>{token.airdrop_details.airdrop_address}</span>
                            </div>
                        </div> : null
                    }
                    <div className="infoPair">
                        <label>Master Address:</label> <span>{token.master_address}</span>
                    </div>
                    <div className="infoPair">
                        <label>Burn Address:</label> <span>{token.master_burn_address}</span>
                    </div>
                    <div className="infoPair">
                        <label>Mining Address:</label> <span>{token.master_mining_address}</span>
                    </div>
                    <div className="infoPair">
                        <label>Owner Address:</label> <span>{token.owner_address}</span>
                    </div>
                </div>
                <div className="infoGroup">
                    {token.generated_status === TOKEN_STATUS.pending && role.can(this.props.currentUser.role, TOKEN_APPROVE)
                        ? <button className="buttonAction" onClick={() => this.handleClick('approve')}>Approve Application</button>
                        : null}
                    {token.generated_status === TOKEN_STATUS.pending && role.can(this.props.currentUser.role, TOKEN_REJECT)
                        ? <button className="buttonAction" onClick={() => this.handleClick('reject')}>Reject Application</button>
                        : null}
                    {token.generated_status === TOKEN_STATUS.complete && role.can(this.props.currentUser.role, TOKEN_PAUSE) ?
                        (
                            <button className="buttonAction" onClick={() => this.handleClick('pause')}>Pause Token</button>
                        )
                        : null}
                    {token.generated_status === TOKEN_STATUS.paused && role.can(this.props.currentUser.role, TOKEN_UNPAUSE) ?
                        (
                            <button className="buttonAction" onClick={() => this.handleClick('complete')}>Unpause Token</button>
                        )
                        : null}

                </div>

                <ReactModal
                    isOpen={this.state.showConfirmModal}
                    className="modal"
                    parentSelector={this.getParent}
                >
                    <div id="modal-message">
                        <h1>Confirmation</h1>
                        <strong>{this.state.modalMessage}</strong>
                        <fieldset className="form form-alpha">
                            {
                                this.state.actionType === 'reject' ?
                                    <fieldset className="form-group">
                                        <input
                                            type="text"
                                            placeholder="reject reason"
                                            onChange={this.updateState('reason')} />
                                    </fieldset>
                                    : null
                            }

                            <fieldset className="form-group">

                                <button onClick={() => this.handleConfirmSubmit()}>OK</button>
                                <button
                                    className="button-sub"
                                    className="button-sub"
                                    onClick={() => this.setState({ showConfirmModal: false })}
                                >
                                    Cancel
                                </button>
                            </fieldset>
                        </fieldset>
                    </div>
                </ReactModal>
                <ReactModal
                    isOpen={this.state.showVerificationCodeModal}
                    className="modal"
                    parentSelector={this.getParent}
                >
                    <div id="modal-message">
                        <h1>Verification</h1>
                        <strong>Please enter your verification code</strong>
                        <fieldset className="form form-alpha">
                            <fieldset className="form-group">
                                <input
                                    type="text"
                                    placeholder="123456"
                                    maxLength={6}
                                    onChange={this.updateState('code')} />

                            </fieldset>
                            <fieldset className="form-group">
                                <button onClick={() => this.handleConfirmSubmit()}>Submit</button>
                                <button
                                    className="button-sub"
                                    onClick={() => this.setState({ showVerificationCodeModal: false })}>
                                    Cancel
                                </button>
                            </fieldset>
                        </fieldset>
                    </div>
                </ReactModal>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TokenDetail);



// WEBPACK FOOTER //
// ./src/components/TokenDetail.js